import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchBalanceOnHandCurrentInfo = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getBalanceOnHandCurrentInfo',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchBalanceOnHandCurrentInfo;
